import React from 'react'
import {Icon} from '@chakra-ui/react'

const LocatorIcon = (props) => {
    return (
        <Icon viewBox="0 0 48 48" id="locator" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.0894 16.4516C30.0894 19.8108 27.3664 22.5337 24.0073 22.5337C20.6481 22.5337 17.9252 19.8108 17.9252 16.4516C17.9252 13.0925 20.6481 10.3695 24.0073 10.3695C27.3664 10.3695 30.0894 13.0925 30.0894 16.4516ZM28.1694 16.4516C28.1694 14.1529 26.306 12.2895 24.0073 12.2895C21.7085 12.2895 19.8452 14.1529 19.8452 16.4516C19.8452 18.7504 21.7085 20.6137 24.0073 20.6137C26.306 20.6137 28.1694 18.7504 28.1694 16.4516Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.04 46.9741V44.2358C21.6784 41.5318 20.0682 39.1725 16.6726 34.6353C14.6706 31.9602 14.1142 31.2064 13.2163 29.9219C9.48883 24.5893 7.67969 20.5326 7.67969 16.3275C7.67969 7.31043 14.9899 0.000244141 24.0069 0.000244141C33.0246 0.000244141 40.3341 7.31013 40.3341 16.3275C40.3341 20.5326 38.5251 24.5894 34.7978 29.9219C33.8997 31.2068 33.3432 31.9607 31.3406 34.6367C27.934 39.1886 26.3246 41.5483 24.96 44.2635V46.9741C24.96 47.5407 24.5302 48.0001 24 48.0001C23.4698 48.0001 23.04 47.5407 23.04 46.9741ZM33.2241 28.8219C32.3428 30.0829 31.7919 30.8292 29.8034 33.4863C26.9237 37.3342 25.295 39.6581 24.007 41.9625C22.719 39.6577 21.09 37.3335 18.2098 33.4849C16.2219 30.8286 15.6712 30.0825 14.79 28.8219C11.2691 23.7848 9.59969 20.0415 9.59969 16.3275C9.59969 8.37081 16.0503 1.92024 24.0069 1.92024C31.9642 1.92024 38.4141 8.37049 38.4141 16.3275C38.4141 20.0416 36.7448 23.785 33.2241 28.8219Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default LocatorIcon
